/**
 * 语言包的实现类
 */

let langDataAll = {};
let currentLang = 'zh-cn';

export function load_lang(langName, langData){
    if(langName in langDataAll){
        langDataAll[langName] = {
            ...langDataAll[langName],
            ...langData,
        };
    }
    else{
        langDataAll[langName] = {
            ...langData,
        };
    }
    return true;
}

export function set_current_lang(langName){
    if(!(langName in langDataAll)){
        langDataAll[langName] = {};
    }

    currentLang = langName;
    return true;
}

export function get_current_lang(langFile = ''){
    if(langFile == ''){
        return currentLang;
    }
    return langFile.replace('{}', currentLang);
}

let lang = new Proxy({}, {
    get: (target, propKey) => {
        if(propKey in langDataAll[currentLang]){
            return langDataAll[currentLang][propKey];
        }
        else{
            return propKey;
        }
    }
});

export {lang}